/* eslint-disable */

export function isNull (obj) {
  if (typeof obj === 'undefined' || obj === null || obj === '') {
    return true
  } else {
    return false
  }
}

export function createYear (_data, fullYear) {
  var daysOfMonth = []
  var sum = 0
  outer:
    for (var i = 0; i <= 11; i++) {
      var date = new Date(fullYear, i).format('yyyy-MM')
      for (var j = 0; j < _data.length; j++) {
        _data[j].date = new Date(_data[j].date).format('yyyy-MM')
        if (_data[j].date == date) {
          sum += _data[j].moneySum
          daysOfMonth.push(_data[j])
          continue outer
        }
      }
      daysOfMonth.push(JSON.parse('{"date":"' + date + '","number":"0","moneySum":"0"}'))
    }
  return {
    daysOfMonth: daysOfMonth,
    sum: sum
  }
}

export function getMonth (date) {
  let year = new Date(date).getFullYear()
  let month = new Date(date).getMonth()
  let arr = []
  for (let i = 0; i <= 11; i++) {
    arr.push(new Date(year, i, 1).format('yyyy-MM-dd'))
  }
  return arr
}

export function getDate (date) {
  let year = new Date(date).getFullYear()
  let month = new Date(date).getMonth()
  let day = new Date(year, month+1, 0).getDate()
  let arr = []
  for (let i = 1; i <= day; i++) {
    arr.push(new Date(year, month , i).format('yyyy-MM-dd'))
  }
  return arr
}

export function createMonth (_data, dates) {
  var daysOfMonth = []
  var sum = 0
  var date = new Date(dates)
  var year = date.getFullYear()
  var month = date.getMonth()
  var days = new Date(year, month + 1, 0).getDate()
  outer:
    for (var i = 1; i <= days; i++) {
      var date = new Date(year, month, i).format('yyyy-MM-dd')
      for (var j = 0; j < _data.length; j++) {
        _data[j].date = new Date(_data[j].date).format('yyyy-MM-dd')
        if (_data[j].date == date) {
          sum += _data[j].moneySum
          daysOfMonth.push(_data[j])
          continue outer
        }
      }
      daysOfMonth.push(JSON.parse('{"date":"' + date + '","number":"0","moneySum":"0"}'))
    }
  return {
    daysOfMonth: daysOfMonth,
    sum: sum
  }
}

export function getTimeFormat (startTime) {
  var startTimeMills = startTime.getTime()
  var endTimeMills = new Date().getTime()
  var diff = parseInt((endTimeMills - startTimeMills) / 1000)// 秒
  var dayDiff = parseInt(Math.floor(diff / 86400))// 天
  var buffer = new Array()
  if (dayDiff < 0) {
    return '[error],时间越界...'
  } else {
    if (dayDiff === 0 && diff < 60) {
      if (diff <= 0) {
        diff = 1
      }
      buffer.push(diff + '秒前')
    } else if (dayDiff === 0 && diff < 120) {
      buffer.push('1 分钟前')
    } else if (dayDiff === 0 && diff < 3600) {
      buffer.push(Math.round(Math.floor(diff / 60)) + '分钟前')
    } else if (dayDiff === 0 && diff < 7200) {
      buffer.push('1小时前')
    } else if (dayDiff === 0 && diff < 86400) {
      buffer.push(Math.round(Math.floor(diff / 3600)) + '小时前')
    } else if (dayDiff === 1) {
      buffer.push('1天前')
    } else if (dayDiff < 7) {
      buffer.push(dayDiff + '天前')
    } else if (dayDiff < 30) {
      buffer.push(Math.round(Math.floor(dayDiff / 7)) + ' 星期前')
    } else if (dayDiff >= 30 && dayDiff <= 179) {
      buffer.push(Math.round(Math.floor(dayDiff / 30)) + '月前')
    } else if (dayDiff >= 180 && dayDiff < 365) {
      buffer.push('半年前')
    } else if (dayDiff >= 365) {
      buffer.push(Math.round(Math.floor(dayDiff / 30 / 12)) + '年前')
    }
  }
  return buffer.toString()
}

Date.prototype.format = function (fmt) {
  var o = {
    'Y+': this.getFullYear(),
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12,
    'H+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  }
  var week = {
    '0': '日',
    '1': '一',
    '2': '二',
    '3': '三',
    '4': '四',
    '5': '五',
    '6': '六'
  }
  var month = {
    '1': 'Jan',
    '2': 'Feb',
    '3': 'Mar',
    '4': 'Apr',
    '5': 'May',
    '6': 'Jun',
    '7': 'Jul',
    '8': 'Aug',
    '9': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec'
  }
  var months = {
    '1': 'January',
    '2': 'February',
    '3': 'March',
    '4': 'April',
    '5': 'May',
    '6': 'June',
    '7': 'July',
    '8': 'August',
    '9': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '')
      .substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt
      .replace(
        RegExp.$1,
        ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '星期'
          : '周')
          : '')
        + week[this.getDay() + ''])
  }
  if (/(Q+)/.test(fmt)) {
    fmt = fmt
      .replace(
        RegExp.$1,
        ((RegExp.$1.length > 0) ? (RegExp.$1.length > 1 ? months[this.getMonth() + 1 + ''] : month[this.getMonth() + 1 + '']) : month[this.getMonth() + 1 + '']))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k])
        : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
